import { createContext, useContext } from 'react';
export var PanelContext = /*#__PURE__*/createContext({});
export var usePanelContext = function () {
  return useContext(PanelContext);
};